export default "__VITE_ASSET__3098517e__"